// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-1V3HM";
var _3 = "content-3GCop";
var _4 = "promoImage-2yp4o";
export { _1 as "__esModule", _2 as "wrapper", _3 as "content", _4 as "promoImage" }
export default { "__esModule": _1, "wrapper": _2, "content": _3, "promoImage": _4 }
